export const anatomyModule = {
  id: "anatomy",
  title: "Uterus Anatomy",
  sections: [
    {
      type: "text",
      content: `<h3>Uterus Anatomy</h3>




       <div class="highlight-box">
          <strong>Quick Facts:</strong>
          <ul>
            <li>📏 Size: About X long and X wide</li>
            <li>⚖️ Weight: X grams each</li>
            <li>📍 Location: X</li>
            <li>🎨 Color:XXX in appearance</li>
          </ul>
        </div>
        ,`,

      image: "/images/lungs/LungAnatomy.jpg",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
    {
      type: "text",
      content: "",
      image: "/images/heart/blood-flow.jpg",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
  ],
};
